import {
  PromoServiceAvailableTypes,
  SAVE_PROMO_SERVICE_AVAILABLE,
} from 'actions/promoServiceAvailable/promoServiceAvailableAction'
import {
  PromoServiceAvailableState,
  initialState,
} from 'reducers/promoServiceAvailable/promoServiceAvailableState'

export const promoServiceAvailableReducer = (
  state = initialState,
  action: PromoServiceAvailableTypes
): PromoServiceAvailableState => {
  switch (action.type) {
    case SAVE_PROMO_SERVICE_AVAILABLE:
      return {
        ...state,
        availablePromoServices: action.availablePromoServices,
      }

    default:
      return state
  }
}
